import React from 'react'
import { Suspense } from 'react'

import { Menu } from 'lucide-react'
import { History as HistoryIcon } from 'lucide-react'
import { User, LogOut } from 'lucide-react'
import Link from 'next/link'
import { useSession, signOut } from 'next-auth/react'

import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger
} from '@/components/ui/sheet'


import { HistorySkeleton } from './history-skelton'


type MobileMenuProps = {
  children: React.ReactNode
}

export function MobileMenu({ children }: MobileMenuProps) {
  const { data: session } = useSession()

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button size="icon">
          <Menu />
        </Button>
      </SheetTrigger>
      <SheetContent className="w-64 rounded-tl-xl rounded-bl-xl" side="left">
        <SheetHeader>
          <SheetTitle className="text-left text-lg font-semibold">Menu</SheetTitle>
        </SheetHeader>
        <div className="mt-4 flex flex-col space-y-3">
          <Link href="/next-gen-travel-search" className="text-sm font-medium">
            Start Your Research
          </Link>
          <Link href="/destinations" className="text-sm font-medium">
            Destinations
          </Link>
          <Link href="/tools" className="text-sm font-medium">
            Tools
          </Link>
          <Link href="/best-of" className="text-sm font-medium">
            Best Of
          </Link>
          {session ? (
            <>
              <Link href="/profile" className="text-sm font-medium flex items-center">
                <User className="mr-2 h-4 w-4" />
                Profile
              </Link>
              <button
                onClick={() => signOut()}
                className="text-sm font-medium flex items-center"
              >
                <LogOut className="mr-2 h-4 w-4" />
                Log out
              </button>
            </>
          ) : (
            <>
              <Link href="/sign-in" className="text-sm font-medium">
                Sign In
              </Link>
              <Link href="/sign-up" className="text-sm font-medium">
                Sign Up
              </Link>
            </>
          )}
        </div>
        <div className="mt-8">
          <SheetTitle className="flex items-center gap-1 text-sm font-normal mb-2">
            <HistoryIcon size={14} />
            History
          </SheetTitle>
          <div className="my-2 h-full pb-12 md:pb-10">
            <Suspense fallback={<HistorySkeleton />}>{children}</Suspense>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}